import { styled, css } from 'styled-components';
import tw from 'twin.macro';

export const StyledPage = tw.div`
mx-auto
 w-full bottom-0

`;
